module.exports = __webpack_public_path__ + "img/gantt-chart.f858b2ce.png";